import React from 'react';
import PropTypes from 'prop-types';
import { Location } from '@reach/router';
import { isBrowser, getPTAUrl, getRedirect } from '../../utils';
import styles from './welcome.module.scss';

import loginBtn from './assets/btn-login.png';
import registerBtn from './assets/btn-register.png';
import updateBtn from './assets/btn-update-player.png';
import logoutBtn from './assets/btn-logout.png';



const logoutClickHandler = logoutFunction => async e => {
    e.preventDefault();
    await logoutFunction();

    window.location.href = getPTAUrl(location ? location : {}, 'logout');
};

const Welcome = ({ loggedIn, player, logout, mobile }) => (
    <div className={mobile ? styles.welcomeMobile : styles.welcome}>
        {isBrowser() ? (
            <Location>
                {({ location }) =>
                    loggedIn ? (
                        <>
                            <p>Welcome, {player.name}</p>
                            <a
                                onClick={logoutClickHandler(logout)}
                                href="/monopoly/users/logout"
                                className={`welcome-link`}
                            >
                                <img src={logoutBtn} alt="Log Out of Player&apos;s Club" />
                            </a>
                            <a
                                href={getPTAUrl(
                                    location ? location : {},
                                    'profile'
                                )}
                                className={`welcome-link`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={updateBtn} alt="Update Player Information" />
                            </a>
                        </>
                    ) : (
                        <>
                            <a
                                href={`${getPTAUrl(
                                    location ? location : {},
                                    'login'
                                )}${location ? getRedirect(location) : ''}`}
                            >
                                <img src={loginBtn} alt="Player&apos;s Club Login" />
                            </a>
                            <a
                                href={getPTAUrl(
                                    location ? location : {},
                                    'register'
                                )}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={registerBtn} alt="New Player Registration" />
                            </a>
                        </>
                    )
                }
            </Location>
        ) : null}
    </div>
);

Welcome.propTypes = {
    loggedIn: PropTypes.bool,
    player: PropTypes.object,
    logout: PropTypes.func.isRequired,
    mobile: PropTypes.bool,
};

Welcome.defaultProps = {
    loggedIn: false,
    player: {},
    mobile: false,
};

export default Welcome;
